/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyResponseModel } from '../../models/client-survey-response-model';
import { UpdateSurveyResponseRequest } from '../../models/update-survey-response-request';

export interface UpdateSurveyResponseAsync$Plain$Params {

/**
 * surveyresponse id
 */
  surveyResponseId: number;
  
    /**
     * surveyresponse request variables
     */
    body?: UpdateSurveyResponseRequest
}

export function updateSurveyResponseAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurveyResponseAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('surveyResponseId', params.surveyResponseId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyResponseModel>;
    })
  );
}

updateSurveyResponseAsync$Plain.PATH = '/api/SurveyResponse/{surveyResponseId}';
